export default __webpack_public_path__ + "static/media/background-login.722138c7.svg";